// 默认路由
const defaultRoutes = [
  {//登录
    path: '/login',
    name: 'login',
	meta: {
			title: '登录'
	},
    component: () => import('@/views/login/index')
  },
  {//首页
	  path: '/',
	  name: 'admin',
	  redirect: '/home',
	  meta: {
			needLogin: true //是否需要登录才能进入
	  },
	  component: () => import('@/views/index'),
	  children: [
		 {
			 path: 'home',
			 name: 'home',
			 meta: {
				title: '米因健康AI后台',
				needLogin: true //是否需要登录才能进入
			 },
			component: () => import('@/views/home/index'),
		 },
		 {
			 path: 'mainNews',
			 name: 'mainNews',
			 meta: {
				title: '消息通知',
				needLogin: true //是否需要登录才能进入
			 },
			component: () => import('@/views/information/index'),
		 },

		 
	  ]
  },
  {//报告打印 - 查看报告
  	  path: '/reportPrint/lookReport',
  	  name: 'lookReport',
  	  meta: {
  			title: '查看报告',
  			needLogin: true //是否需要登录才能进入
  	  },
  	  component: () => import('@/views/reportPrint/lookReport')
  },
  {//报告打印 - 打印模板
  	  path: '/reportPrint/printTemplate',
  	  name: 'printTemplate',
  	  meta: {
  			title: '报告打印',
  			needLogin: true //是否需要登录才能进入
  	  },
  	  component: () => import('@/views/reportPrint/printTemplate')
  },
  {//所有不存在路由进入login
	  path: '*',
	  name: '404',
	  redirect: '/login'
  }
  
];

export default defaultRoutes.concat();